(function () {
  document.querySelectorAll('[data-alive-hero]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-alive-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-alive-hero-dot]'));
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === index);
      });
      dots.forEach(function (dot, n) {
        dot.classList.toggle('is-active', n === index);
      });
    }

    function next() {
      show(index + 1);
    }

    function restart() {
      if (timer) window.clearInterval(timer);
      timer = window.setInterval(next, 6500);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.index, 10));
        restart();
      });
    });

    var prevBtn = hero.querySelector('[data-alive-hero-prev]');
    var nextBtn = hero.querySelector('[data-alive-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); restart(); });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      restart();
    }
  });
})();
